export const GET_PLANS_START = 'GET_PLANS_START'
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS'
export const GET_PLANS_FAIL = 'GET_PLANS_FAIL'
export const RESET_PLANS = 'RESET_PLANS'

export const GET_PLAN_START = 'GET_PLAN_START'
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS'
export const GET_PLAN_FAIL = 'GET_PLAN_FAIL'

export const GET_PLAN_COMMENTS_START = 'GET_PLAN_COMMENTS_START'
export const GET_PLAN_COMMENTS_SUCCESS = 'GET_PLAN_COMMENTS_SUCCESS'
export const GET_PLAN_COMMENTS_FAIL = 'GET_PLAN_COMMENTS_FAIL'

export const GET_PLAN_FABRICS_START = 'GET_PLAN_FABRICS_START'
export const GET_PLAN_FABRICS_SUCCESS = 'GET_PLAN_FABRICS_SUCCESS'
export const GET_PLAN_FABRICS_FAIL = 'GET_PLAN_FABRICS_FAIL'

export const GET_PLAN_PROFILE_START = 'GET_PLAN_PROFILE_START'
export const GET_PLAN_PROFILE_SUCCESS = 'GET_PLAN_PROFILE_SUCCESS'
export const GET_PLAN_PROFILE_FAIL = 'GET_PLAN_PROFILE_FAIL'

export const GET_PLAN_FILTERS_START = 'GET_PLAN_FILTERS_START'
export const GET_PLAN_FILTERS_SUCCESS = 'GET_PLAN_FILTERS_SUCCESS'
export const GET_PLAN_FILTERS_FAIL = 'GET_PLAN_FILTERS_FAIL'

export const UPDATE_PLAN = 'UPDATE_PLAN'

export const ADD_COMMENT_START = 'ADD_COMMENT_START'
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS'
export const ADD_COMMENT_FAIL = 'ADD_COMMENT_FAIL'
